import HttpService from "./http.service";

class ProductService {

  // Add a new product 
  addProduct = async (payload) => {
    const endpoint = 'products';
    return await HttpService.post(endpoint, payload);
  }

  // Update a product by its ID
  updateProduct = async (productId, payload) => {
    const endpoint = `products/${productId}`;
    return await HttpService.patch(endpoint,payload);
  }

  // Get all products
  getAllProducts = async () => {
    const endpoint = 'products';
    return await HttpService.get(endpoint);
  }

// Get products for a specific dispatch
  getDispatchProducts = async (dispatchId) => {
    const endpoint = `products/dispatch/${dispatchId}`;
    return await HttpService.get(endpoint);
  }

  // Get a product by its ID
  getProductById = async (productId) => {
    const endpoint = `products/${productId}`;
    return await HttpService.get(endpoint);
  }

  // Get products for a specific organization
  getOrgProducts = async (orgId) => {
    const endpoint = `products/org/${orgId}`;
    return await HttpService.get(endpoint);
  }

  // productService.js
  uploadProductFile = async (payload) => {
    const endpoint = 'products/upload-file';

    const formData = new FormData();
    formData.append('file', payload.file); // Actual File object
    formData.append('data[attributes][fileName]', payload.data.attributes.fileName);
    formData.append('data[attributes][organization]', payload.data.attributes.organization);
    formData.append('data[attributes][folderPath]', payload.data.attributes.folderPath);

    return await HttpService.post(endpoint, formData, {
      headers: { 'Content-Type': 'multipart/form-data' } // optional if using axios; fetch will add automatically
    });
  };

  // Delete files from S3
  deleteFilesFromS3 = async (payload) => {
    const endpoint = 'products/delete/files';
    return await HttpService.patch(endpoint, payload);
  };

  // Get product totals for a specific organization
  getProductTotals = async (orgId) => {
    const endpoint = `products/totals/${orgId}`;
    return await HttpService.get(endpoint);
  };

  // Get product diversity data for clients dashboard pie chart
  getProductDiversity = async (orgId) => {
    const endpoint = `products/diversity/${orgId}`;
    return await HttpService.get(endpoint);
  };

  // Get a file form S3
  getProductFile = async (s3Key) => {
    const encodedPath = encodeURIComponent(s3Key);
    const endpoint = `products/getfile/${encodedPath}`;
    return await HttpService.get(endpoint);
  };

  // Delete a product by its ID
  deleteProduct = async (productId, userId) => {
    const endpoint = `products/${productId}/${userId}`;
    return await HttpService.delete(endpoint);
  };

}

export default new ProductService();